import React, { useState, useEffect } from 'react';
import Markdown from 'global/components/Markdown';
import NavToTop from 'feature/nav/NavToTop';
import { GridContainer } from 'global/components/perform-grid';
import { ChangelogContent } from './Changelog.styles';

import changelog from 'global/../../CHANGELOG.md';
// import faq from 'global/../../README_FAQ.md';

export default function Changelog(props) {
  const [markdown, setMarkdown] = useState('');
  const [page, setPage] = useState(changelog);
  // const [value, setValue] = useState(0);

  useEffect(() => {
    fetch(page)
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
  }, [page]);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // }

  return (
    <GridContainer>
      <ChangelogContent>
        {/*<Tabs value={value} onChange={handleChange} textColor={"primary"} indicatorColor={"primary"}>
          <Tab label='Changelog' onClick={() => {setPage(changelog)}} />
          <Tab label='FAQ' onClick={() => {setPage(faq)}} />
        </Tabs>*/}
        <NavToTop />
        <Markdown>{markdown}</Markdown>
      </ChangelogContent>
    </GridContainer>
  );
}
